/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, Button, SxProps, Theme, Typography } from "@mui/material";
import { mergeSx } from "@/src/utils/mergeSx";
import { ourServiceTabContentStyle } from "@/src/components/Sections/Generic/OurService/ourServiceTabContentStyle";
import Grid from "@mui/material/Grid";
import { useAuthDialog } from "@/src/provider/AuthDialog/AuthDialogProvider";

export type OurServiceTabContentProps = {
  title: string;
  subTitle?: string;
  description: string;
  image: {
    src: string;
  };
  sx?: SxProps<Theme>;
  id: string;
};

export default function OurServiceTabContent({ title, subTitle, description, image, id, sx }: OurServiceTabContentProps) {
  const { setView } = useAuthDialog();

  return (
    <Grid container role="tabpanel" sx={mergeSx(ourServiceTabContentStyle.ourServiceTabContent, sx)} direction={"row"} spacing={{ xs: 6, md: 22 }} id={id}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Typography sx={{ marginBottom: "1rem" }} component={"h3"} variant={"h5"}>
          {title}
          {!!subTitle && (
            <>
              <br />
              {subTitle}
            </>
          )}
        </Typography>
        <Typography sx={{ marginBottom: "2rem" }}>{description}</Typography>
        <Button variant={"contained"} onClick={() => setView({ type: "login" })}>
          Jetzt starten
        </Button>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Box component={"img"} sx={ourServiceTabContentStyle.image} src={image.src} width={534} height={912} alt={""} />
      </Grid>
    </Grid>
  );
}
